/**
 * Returns the active org's configured display timezone (IANA string), or
 * 'UTC' when unset.  This is the single source of truth for all instant
 * formatter callsites in the web UI (A2F-1019).
 *
 * Resolution order: org setting if present → 'UTC'.
 * Per-user override is deferred (A2F-1019 scope note); the tz-arg seam
 * is already in place in formatInstant/timeAgo for a future 1-line change.
 */
import { useActiveOrg } from './ActiveOrgContext';

export function useDisplayTimezone(): string {
  const { activeOrg } = useActiveOrg();
  return activeOrg?.displayTimezone ?? 'UTC';
}
